import { createContext, useContext } from 'react';

/** How the app draws its icons: in the text colour, or in colour. */
export type IconStyle = 'plain' | 'candy';

export interface IconStyleContextValue {
  /** The style on screen. */
  style: IconStyle;
}

export const IconStyleContext = createContext<IconStyleContextValue>({
  style: 'plain',
});

export function useIconStyle(): IconStyleContextValue {
  return useContext(IconStyleContext);
}
